/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState} from 'react';
import {ReactComponent as Exclamation} from "../assets/img/icons/exclamation-grey.svg";
import LicenseImage from "../assets/img/licenseImage.png";
import {useTranslation} from "react-i18next";

const VehicleLicence = () => {

    const { t, i18n } = useTranslation();
    const [showleLicence, setShowleLicence] = useState(false);

    const toggleLicence = () =>{
        setShowleLicence(v => !v);
    }
    const closeModal = (e) =>{
        setShowleLicence(false);
    }

    return (
        <div className="row small-gutters justify-content-start justify-content-md-end mb-3 SearchByCar__info">
            <div className='col-auto'>
                <Exclamation/>
            </div>
            <div className='col-auto'>
                <span className='text-14 color-70'>{ t('parts.help' ) }</span>
            </div>
            <div className='col-auto'>
                <span className='d-inline-block text-14 color-green weight-500' onClick={toggleLicence}>{ t('parts.click' ) }</span>
            </div>

            <div className={`modal ${showleLicence ? "opened" : ""} `} onClick={ closeModal }>
                <div className="modal-dialog modal-lg" role="document" onClick={e => {
                    // do not close modal if anything inside modal content is clicked
                    e.stopPropagation();
                }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Find the model data in vehicle’s licence</h5>
                            <button type="button" className="close" aria-label="Close" onClick={closeModal}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body text-center">
                            <img className="img-fluid" src={LicenseImage} alt="License" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default VehicleLicence;
